import React from "react";
import { cardsData } from "../../../../constant/data";

const Bonuses = () => {
  return (
    <div
      >
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="flex items-center gap-5 flex-col justify-center">
          <h1 className="lg:text-4xl text-3xl font-bold text-center mb-12">
          Order 6 Bottles And Get{" "}
          <span className="text-[#ff1300]"> 1 eBook + 1 community group!</span>
          </h1>
          <div className="w-36 h-1.5 bg-[#d9d9d9]" />

          <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-8 items-start">
            {cardsData.map((card) => (
              <div key={card.id} className="space-y-6">
                <div className="flex items-center flex-col">
                  <img src={card.imgSrc} alt={card.title}  className="w-full h-[450px]"/>
                  <div
                    className={` p-4 w-full h-20`}
                    style={{ backgroundColor: card.bgColor }}>
                    {card.note && (
                      <p className="text-xs text-center text-white font-light pb-2">
                        {card.note}
                      </p>
                    )}

                    <p className="text-[22px] font-semibold text-white text-center">
                      {card.title}
                    </p>
                  </div>
                </div>
                <div className="flex items-center flex-col justify-center gap-4">
                  <p className="text-[32px] font-light">
                    RRP:{" "}
                    <strike className="decoration-red-500">${card.rrp}</strike>{" "}
                    Today:{" "}
                    <span className="text-[#ff1300] uppercase font-bold">
                      {card.todayPrice}
                    </span>
                  </p>
                  <span className=" leading-[30px] text-justify font-light text-[20px] text-[#192b4b]">
                    {card.description}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Bonuses;
